// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { createContext, useContext } from 'react';

interface MapContextData {
  map: google.maps.Map | null;
}

export const MapContext = createContext<MapContextData | undefined>(undefined);

/**
 * A React hook that provides access to the map context.
 */
export function useMap() {
  const context = useContext(MapContext);

  if (context === undefined) {
    const error = 'useMap must be used within a MapContext provider';

    throw new Error(error);
  }

  return context;
}
